import styled from 'styled-components';

export const SubLabelStyle = styled.label`
  height: 17px;
  width: 100%;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 15px;
  line-height: 17px;
  margin: 0 8px;
  box-sizing: border-box;
`;

export const RequiredSymbol = styled.span`
  color: ${({ theme }) => theme.palette.error.main};
  padding-left: 5px;
`;
